var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.0498047C1.13801 0.0498047 1.4502 0.361989 1.4502 0.75V9.5498H8.5498V5.25C8.5498 4.31199 9.31199 3.5498 10.25 3.5498H14.25C16.2943 3.5498 17.9502 5.20574 17.9502 7.25V13.25C17.9502 13.638 17.638 13.9502 17.25 13.9502C16.862 13.9502 16.5498 13.638 16.5498 13.25V10.9502H1.4502V13.25C1.4502 13.638 1.13801 13.9502 0.75 13.9502C0.361989 13.9502 0.0498047 13.638 0.0498047 13.25V0.75C0.0498047 0.361989 0.361989 0.0498047 0.75 0.0498047ZM10.25 4.9502C10.0849 4.9502 9.9502 5.08489 9.9502 5.25V9.5498H16.5498V7.25C16.5498 5.97864 15.5214 4.9502 14.25 4.9502H10.25ZM5 3.5498C5.64978 3.5498 6.27296 3.80811 6.73242 4.26758C7.19189 4.72704 7.4502 5.35022 7.4502 6C7.4502 6.64978 7.19189 7.27296 6.73242 7.73242C6.27296 8.19189 5.64978 8.4502 5 8.4502C4.35022 8.4502 3.72704 8.19189 3.26758 7.73242C2.80811 7.27296 2.5498 6.64978 2.5498 6C2.5498 5.35022 2.80811 4.72704 3.26758 4.26758C3.72704 3.80811 4.35022 3.5498 5 3.5498ZM5 4.9502C4.72152 4.9502 4.45473 5.0609 4.25781 5.25781C4.0609 5.45473 3.9502 5.72152 3.9502 6C3.9502 6.27848 4.0609 6.54527 4.25781 6.74219C4.45473 6.9391 4.72152 7.0498 5 7.0498C5.27848 7.0498 5.54527 6.9391 5.74219 6.74219C5.9391 6.54527 6.0498 6.27848 6.0498 6C6.0498 5.72152 5.9391 5.45473 5.74219 5.25781C5.54527 5.0609 5.27848 4.9502 5 4.9502Z",
    fill: "#445162",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepsIcon);
export default __webpack_public_path__ + "static/media/sleeps-icon.992a6cadf940901807507b50ea6cf28a.svg";
export { ForwardRef as ReactComponent };